import React from "react";

import { ButtonTypes } from "../Button";
import { SectionRetry } from "./styles";
import { SectionRetryButtonProps } from "./types";

export const SectionRetryButton: React.FC<SectionRetryButtonProps> = ({
  onClick,
  className,
}) => (
  <SectionRetry
    type={ButtonTypes.cancel}
    size="small"
    className={className}
    onClick={onClick}
  >
    Try again
  </SectionRetry>
);
